"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceGenerationInvoices = class UcInvoiceGenerationInvoices extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    sse = {
        cleanup: true,
    };
    beforeCreate() {
    }
    processMessage(...args) {
        const msg = args[0];
        if (msg.event === 'InvoiceGeneratorStatus') {
            this.$refs.panel.updateStatus(msg.data);
        }
        if (msg.event === 'InvoiceCreated') {
            this.$refs.grid.dataView.addItem(msg.data);
        }
        if (msg.event === 'InvoiceUpdated') {
            this.$refs.grid.dataView.updateItem(msg.data.id, msg.data);
        }
        if (msg.event === 'InvoiceDeleted') {
            this.$refs.grid.dataView.removeItem(msg.data.id);
        }
    }
    onCreateInvoicesPayload(...args) {
        return this.$imodal
            .show({ name: 'CompleteInvoicesAlt' })
            .then(result => {
            if (!result || result.cancel || !result.value) {
                return;
            }
            return this.selectedItems.map(p => ({
                ...result.value,
                invoice_id: p.id,
            }));
        });
    }
    getDownloadViewsPayload(...args) {
        return {
            identities: _.chain(this.selectedItems)
                .map(p => p.id)
                .uniq()
                .value()
        };
    }
    boundDownloadViewsPayloadMethod(...args) {
        if (!this._getDownloadViewsPayload) {
            this._getDownloadViewsPayload = this.getDownloadViewsPayload.bind(this);
        }
        return this._getDownloadViewsPayload;
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    gridName;
    resizeTrigger;
    selectedItems;
    ts;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_draft_invoices');
    }
    ux;
    b_1040167445267876_columnDefaults;
    b_1040167445267876_columns;
    dataMembers = ['gridName', 'resizeTrigger', 'selectedItems', 'ts', 'ds', 'ux', 'b_1040167445267876_columnDefaults', 'b_1040167445267876_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                gridName: "draftInvoices",
                resizeTrigger: 0,
                selectedItems: [],
                ts: null,
                ds: null,
                ux: null,
                b_1040167445267876_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_1040167445267876_columns: [{
                        field: "contract_number",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Contract"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "contract",
                            navigateOnIconClick: true,
                            params: {
                                id: "contract_id",
                            },
                        },
                    },
                    {
                        name: this.$fn.pgettext("Invoices", "Period start"),
                        params: {
                            sortPath: "billing_period.start",
                        },
                        field: "billing_period.start",
                        type: "date",
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "billing_period.start",
                                },
                            },
                        ],
                    },
                    {
                        name: this.$fn.pgettext("Invoices", "Period end"),
                        params: {
                            sortPath: "billing_period.end",
                        },
                        field: "billing_period.end",
                        type: "date",
                        formatter: [{
                                name: "getvalue",
                                opts: {
                                    field: "billing_period.end",
                                },
                            },
                        ],
                    },
                    {
                        field: "invoice_number",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Invoice Number"),
                        type: "command",
                        formatter: {
                            name: "link",
                            href: "#",
                        },
                    },
                    {
                        field: "company_name",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Company"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "company_id",
                            },
                        },
                    },
                    {
                        field: "client_name",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Client"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "client_id",
                            },
                        },
                    },
                    {
                        field: "rental_name",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Rental"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "rental_id",
                            },
                        },
                    },
                    {
                        field: "site_name",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Site"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "property",
                            navigateOnIconClick: true,
                            params: {
                                id: "site_id",
                            },
                        },
                    },
                    {
                        field: "billing_category",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Billing category"),
                    },
                    {
                        field: "net_amount",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Net"),
                        type: "number",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "vat_amount",
                        name: this.$fn.pgettext("InvoiceBrowserView", "VAT"),
                        type: "number",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "amount",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Amount"),
                        type: "number",
                        formatter: {
                            name: "number",
                        },
                    },
                    {
                        field: "currency",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Currency"),
                    },
                    {
                        field: "invoice_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Invoice date"),
                        type: "date",
                    },
                    {
                        field: "fulfillment_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Fulfillment date"),
                        type: "date",
                    },
                    {
                        field: "due_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Due date"),
                        type: "date",
                    },
                    {
                        field: "accounting_date",
                        name: this.$fn.pgettext("InvoiceBrowserView", "Accounting date"),
                        type: "date",
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return;
        }
        return null;
    }
    async act_1040167445267876_setData_7468_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_1040167445267876_selectedRowsChanged(event, scope) {
        return await this.actions.evh_1040167445267876_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_1040167445267876_showModal_7470_getActionArgs($event) {
        return {
            name: "Invoice",
            props: {
                oid: $event.data.data.id,
                modal: true,
            },
        };
    }
    async evh_1040167445267876_command_7469_getWhen($event) {
        return $event.data.column.id === 'invoice_number';
    }
    async evh_1040167445267876_command(event, scope) {
        return await this.actions.evh_1040167445267876_command.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_reloadSlickgrid_7474_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_7789867021953041_close_7473_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_7789867021953041_showModal_7472_getActionArgs($event) {
        return {
            name: "BatchInvoiceEditor",
            props: {
                invoices: this.selectedItems,
            },
        };
    }
    async evh_7789867021953041_click(event, scope) {
        return await this.actions.evh_7789867021953041_click.executeFromDOM(this, event, scope);
    }
    async act_3468003412020058_reloadSlickgrid_7478_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async act_3468003412020058_request_7476_getActionArgs($event) {
        return {
            operation: "delete_draft_invoices",
            data: {
                invoices: this.selectedItems.map(p => p.id)
            },
        };
    }
    async evh_3468003412020058_click(event, scope) {
        return await this.actions.evh_3468003412020058_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_1040167445267876_setData_7468 = new core_1.actions.SetDataAction({
            actionArgs: this.act_1040167445267876_setData_7468_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_selectedRowsChanged_7467 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_setData_7468,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_1040167445267876_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_selectedRowsChanged_7467],
        });
        const act_1040167445267876_showModal_7470 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_1040167445267876_showModal_7470_getActionArgs,
            events: [],
        });
        const evh_1040167445267876_command_7469 = new core_1.actions.EventHandlerImpl({
            action: act_1040167445267876_showModal_7470,
            event: "command",
            when: this.evh_1040167445267876_command_7469_getWhen,
            displayName: "showModal",
        });
        const evh_1040167445267876_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1040167445267876_command_7469],
        });
        const act_7789867021953041_reloadSlickgrid_7474 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_7789867021953041_reloadSlickgrid_7474_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_close_7473 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_reloadSlickgrid_7474,
            event: "close",
            when: this.evh_7789867021953041_close_7473_getWhen,
            displayName: "reloadSlickgrid",
        });
        const act_7789867021953041_showModal_7472 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_7789867021953041_showModal_7472_getActionArgs,
            events: [evh_7789867021953041_close_7473],
        });
        const evh_7789867021953041_click_7471 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_showModal_7472,
            event: "click",
            displayName: "showModal",
        });
        const evh_7789867021953041_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_click_7471],
        });
        const act_3468003412020058_reloadSlickgrid_7478 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_3468003412020058_reloadSlickgrid_7478_getActionArgs,
            events: [],
        });
        const evh_3468003412020058_success_7477 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_reloadSlickgrid_7478,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_3468003412020058_request_7476 = new core_1.actions.RequestAction({
            actionArgs: this.act_3468003412020058_request_7476_getActionArgs,
            displayName: "deleteItems",
            events: [evh_3468003412020058_success_7477],
        });
        const evh_3468003412020058_click_7475 = new core_1.actions.EventHandlerImpl({
            action: act_3468003412020058_request_7476,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_3468003412020058_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3468003412020058_click_7475],
        });
        return {
            act_1040167445267876_setData_7468,
            evh_1040167445267876_selectedRowsChanged_7467,
            evh_1040167445267876_selectedRowsChanged,
            act_1040167445267876_showModal_7470,
            evh_1040167445267876_command_7469,
            evh_1040167445267876_command,
            act_7789867021953041_reloadSlickgrid_7474,
            evh_7789867021953041_close_7473,
            act_7789867021953041_showModal_7472,
            evh_7789867021953041_click_7471,
            evh_7789867021953041_click,
            act_3468003412020058_reloadSlickgrid_7478,
            evh_3468003412020058_success_7477,
            act_3468003412020058_request_7476,
            evh_3468003412020058_click_7475,
            evh_3468003412020058_click,
            deleteItems: act_3468003412020058_request_7476,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], UcInvoiceGenerationInvoices.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceGenerationInvoices.prototype, "onSize", null);
UcInvoiceGenerationInvoices = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceGenerationInvoices);
exports.default = UcInvoiceGenerationInvoices;
vue_property_decorator_1.Vue.component("UcInvoiceGenerationInvoices", UcInvoiceGenerationInvoices);
